import React from 'react'

import { Alert } from 'ui'
import { t } from 'translations'

function UserCantBeInvitedAlert({ values, _id }) {
  const hasNoEmailNorPhoneNumber = !values.emails.length && !values.phoneNumbers.length

  return (
    <Alert variant="warning" show={!!hasNoEmailNorPhoneNumber && _id === 'new'}>
      {t(`manager.users.form.USER_CANT_BE_INVITED`)}
    </Alert>
  )
}

export default UserCantBeInvitedAlert
